<template>
    <split-pane  :min-percent='5' :default-percent='40' split="vertical" style="background:white; height:100%">
        <template slot="paneL">
            <!-- 最外层容器：必须用纵向flex，占满面板高度，是拖拽生效的基础 -->
            <div style="width:100%;height:100%;display:flex;flex-direction:column;overflow:hidden;">
                <!-- 1. 顶部筛选栏：固定高度，不需要参与拖拽 -->
                <div style="width:100%;display:flex;flex-shrink:0;overflow:hidden;background:white;border-bottom:2px solid #389;padding:2px;">
                    <div style="font-size:12px;margin-right:10px;margin-left:5px;font-weight:600;color:black;line-height:30px">{{ $LANG('0939', '计划状态：') }}</div>
                    <el-select v-model="selparam" @change="inputQry" size="small" style="height:30px;width:120px" :placeholder="$LANG('1664', '请选择')">
                        <el-option value="ALL" :label="$LANG('0040', '所有记录')"></el-option>
                        <el-option value="Y" :label="$LANG('2028', '已计划需求')"></el-option>
                        <el-option value="N" :label="$LANG('2033', '未计划需求')"></el-option>
                    </el-select>
                    <div style="min-width:80px;line-height:26px;height:26px;margin-left:25px;margin-top:2px">
                        <el-button size="mini" @click="expOrdList" type="primary">
                            <div style="font-size:12px;margin-top:-4px"><i class="iconfont icon-xiazai"></i> 导出订单资料</div>
                        </el-button>
                    </div>
                </div>

                <!-- 2. 上方订单表格：动态绑定高度，最小高度限制 -->
                <div  ref="topTableWrap" 
                    :style="{ height: topTableHeight + 'px', flexShrink: 0 }"
                    style="width:100%;overflow:hidden;" >
                    <el-table :data="ordData"
                        border
                        disabled-hover
                        size="small"
                        :cell-style="{padding:'2px'}"
                        :header-cell-style="{'padding':'0px','text-align':'center'}"
                        header-cell-class-name="clearPadding"
                        :height="topTableHeight"
                        class="custom-table-border"
                        :span-method="objectSpanMethod"
                        :row-key="getRowKey"
                        :row-class-name="tabRowClass"
                        @row-click="ordClick"
                        v-loading="v_loading"
                        :element-loading-text="$LANG('1959', '加载中')"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(255, 251, 255, 0.8)"
                        style="width:100%;"
                        ref="tabref"
                        highlight-current-row>
                        <el-table-column :label="$LANG('0310', '序号')" type="index" width="55" fixed>
                            <template slot="header">
                                <el-link @click="rowShow" style="font-size:12px;color:#404eff">
                                    <el-tooltip :content="$LANG('0852', ' 清除条件')" effect="light">
                                        <i class="iconfont icon-shanchu1"></i>
                                    </el-tooltip>
                                </el-link>
                            </template>
                        </el-table-column>
                        <el-table-column v-for="(item,index) in ordArr.filter(item=>item.thide=='N')" :key="index"
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"
                            :fixed="item.key=='OPER'"
                            :min-width="item.width">
                            <el-table-column resizable :prop="item.key" :label="item.title" show-overflow-tooltip :min-width="item.width">
                                <template slot="header" slot-scope="scope">
                                    {{scope.row}}
                                    <el-date-picker v-if="item.edcss=='date'" @change="inputQry" :placeholder="$LANG('1664', '请选择')" size="mini" type="date" clearable v-model="v_row[item.key]" value-format="yyyy-MM-dd" style="width:100%"></el-date-picker>
                                    <input type="number" :placeholder="$LANG('0472', '数字框')" clearable @keydown.enter="inputQry" v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%">
                                    <input :disabled="item.disabled=='Y'" v-else @keyup.enter="inputQry" v-model="v_row[item.key]" size="mini" :placeholder="$LANG('1663', '请输入')">
                                </template>
                                <template slot-scope="scope">
                                    <el-link :underline="false" v-if="item.key=='IDNO'" @click="ordShow(scope.row)">
                                        <span v-text="scope.row[item.key]" style="font-size:11px;border-bottom:1px solid blue"></span>
                                        <span v-if="scope.row['ISPRE']=='Y'" style="margin-left:2px;font-size:12px;width:20px;height:20px;background:red;color:white;padding-left:2px">{{ $LANG('1661', '预') }}</span>
                                    </el-link>
                                    <div v-else-if="item.key=='OPER'">
                                        <el-link :disabled="editBool" @click="mrpCalc(scope.row)" :underline="false"><span style="font-size:12px;margin-right:5px;border-bottom:1px solid red;"> 运算 </span></el-link>
                                        <el-link disabled :underline="false" style="margin-left:15px"><span style="font-size:12px;margin-right:5px;border-bottom:1px solid red">{{ $LANG('0409', '锁定') }} </span></el-link>
                                    </div>
                                    <el-checkbox v-else-if="item.edcss=='checkbox'" true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                    <span v-else v-text="scope.row[item.key]"></span>
                                </template>
                            </el-table-column>
                        </el-table-column>
                    </el-table>
                </div>

                <!-- 3. 拖拽分隔条：加大可点击区域，鼠标悬浮有样式反馈，事件绑定修复 -->
                <div 
                    class="table-resize-bar"
                    @mousedown="startVerticalResize"
                    style="height:8px;flex-shrink:0;background:#f5f7fa;cursor:row-resize;display:flex;align-items:center;justify-content:center;z-index:100;user-select:none;transition:background 0.2s;"
                >
                    <div style="width:60px;height:3px;background:#dcdfe6;border-radius:2px;transition:background 0.2s;"></div>
                </div>

                <!-- 4. 中间物料tab栏：固定高度，不参与拖拽 -->
                <div style="display:flex;flex-shrink:0;line-height:25px;background:#ECF5FF;min-width:400px">
                    <div class="oneMenu" @click="itemClick(index,item)" v-for="(item,index) in matData" :key="index">
                        <div :title="item['MATNO']+`(`+item.MATTYNM+`)`" style="width:115px;cursor:pointer;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;margin-left:4px;border-right:1px solid #ccc" :class="{active: actitem=== index}">
                            {{item['MATNO']}}({{item['MATTYNM']}})
                        </div>
                    </div>
                </div>

                <!-- 5. 下方BOM树表格：flex:1 自动占满剩余高度  -->
                <div style="flex:1;overflow:hidden;width:100%;">
                    <el-table :data="treeData"
                        border
                        disabled-hover
                        style="width:100%;"
                        size="small"
                        :cell-style="{'padding-top':'3px','padding-bottom':'3px','margin-left':'-4px','color':'black'}"
                        :header-cell-style="{'padding':'4px','background':'#389','color':'white'}"
                        height="100%"
                        ref="reftree"
                        row-key="usetool"
                        @row-click="treeClick"
                        :expand-row-keys="expkeys"
                        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                        class="custom-table-border"
                        v-loading="t_loading"
                        :element-loading-text="$LANG('1959', '加载中')"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(255, 251, 255, 0.8)"
                        highlight-current-row>
                        <el-table-column :label="$LANG('0310', '序号')" type="index" width="55"></el-table-column>
                        <el-table-column :label="$LANG('0543', '产品树状') + 'BOM'" prop="label" :min-width="170" :show-overflow-tooltip="true" align="left"></el-table-column>
                        <el-table-column v-for="(item,index) in treeCol.filter(item=>item.thide=='N'&& item.key!=='label')" :key="index"
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"
                            :min-width="item.width">
                            <template slot-scope="scope">
                                <el-link @click="setType(scope.row)" v-if="item.key=='stfg'" :underline="false"><span style="border-bottom:1px solid red;font-size:12px">{{scope.row[item.key]}}</span></el-link>
                                <div v-else v-text="scope.row[item.key]" style="float:left;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;width:100%;text-align:left"></div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </template>
        <template slot="paneR"> 
            <div style="width:100%;height:100%;display:flex;flex-direction:column;overflow:hidden;">
                <div style=" width:100%;display:flex;line-height:30px;height:30px;border-left:4px solid #5cadff;padding-left:3px;background: #808695;color:white;">
                    <div style="font-size:12px;margin-left:5px;font-weight:600"> {{ $LANG('1114', '生产任务单') }}</div>
                    <el-checkbox @change="selChg" v-model="v_selAll" true-label="Y" style="margin-left:10px;color:white" false-label="N">
                        <span style="font-size:12px;color:white">{{ $LANG('0263', '全选') }}</span>
                    </el-checkbox> 
                    <div style="width:110px; line-height:22px;height:22px;margin-left:20px" >
                        <el-button size="mini"  @click="nextGen" type="primary" ><div style="font-size:12px;margin-top:-3px "><i class="iconfont icon-caidanxiajiantou"></i>{{ $LANG('1046', '下推投料单') }} </div></el-button>
                    </div>  
                </div>
                <!-- 正确写法 -->
                <div  ref="rightTopWrap" 
                    class="right-top-table-wrap"
                    :style="{ height: rightTopHeight + 'px' }">
                    <el-table  :data="taskData" 
                            border     
                            class="custom-table-border"                       
                            disabled-hover
                            :cell-style="{padding:'2px'}"
                            style="overflow:auto;margin-top:1px;"
                            size="small"
                            ref="rightTopTab"
                            :height="rightTopHeight" 
                            @row-click="pckClick"
                            highlight-current-row>
                        <el-table-column :label="$LANG('0310', '序号')" type="index" width="50"></el-table-column>
                        <el-table-column  v-for="(item,index ) in taskCol.filter(item=>item.thide=='N')" :key="index"
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            :min-width="item.width">
                            <template  slot-scope="scope" >
                                <el-link v-if="item.key=='IDNO'" :underline="false"  @click="taskShow(scope.row,scope.row['BILLTY'])"><div style="color:#409eff;border-bottom:1px solid red;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>
                                <el-tag  v-else-if="item.key=='IDTY' && scope.row['BILLTY']=='IN'" size="mini" type="primary" effect="dark">{{scope.row[item.key]}}</el-tag>
                                <el-tag  v-else-if="item.key=='IDTY' && scope.row['BILLTY']=='OUT'" size="mini" type="danger" effect="dark">{{scope.row[item.key]}}</el-tag>
                                <el-checkbox :disabled="scope.row['ISPICK']=='Y'" v-else-if="item.key=='SEL'" v-model="scope.row[item.key]"  true-label="Y" false-label="N"></el-checkbox>
                                <el-tag v-else-if="item.edcss=='checkbox' &&scope.row[item.key]=='Y' "  size="mini" type="primary" effect="dark">{{ $LANG('2047', '是') }}</el-tag>
                                <el-tag v-else-if="item.edcss=='checkbox' &&scope.row[item.key]=='N' "  size="mini" type="info" effect="dark">{{ $LANG('2044', '否') }}</el-tag>
                                
                                <div v-else  >{{scope.row[item.key]}}</div>
                            </template>
                        </el-table-column>             
                    </el-table> 
                </div>
                 <!-- ========== 右边拖拽分隔条：和左边共用样式，事件单独绑定 ========== -->
                <div  class="table-resize-bar"
                    @mousedown="startRightResize" 
                    style="height:8px;flex-shrink:0;background:#f5f7fa;cursor:row-resize;display:flex;align-items:center;justify-content:center;z-index:100;user-select:none;transition:background 0.2s;">
                    <div style="width:60px;height:3px;background:#dcdfe6;border-radius:2px;transition:background 0.2s;"></div>
                </div>
                <div style="line-height:25px;height:28px; background: #ECF5FF;min-width:400px;display:flex; ">
                    <div style="width:380px; display:flex;margin-top:2px">
                        <el-tabs v-model="v_active" @tab-click="tabClick(v_active)" style="margin-top:-10px;height:20px;font-size:12px ">
                            <el-tab-pane  name="one">
                                <span slot="label"><i class="iconfont icon-huizong" style="margin-left:4px;"></i> {{ $LANG('2096', '请购汇总') }}</span>
                            </el-tab-pane>
                            <el-tab-pane  name="two"> 
                                <span slot="label"><i class="iconfont icon-a-baobiaoguanlibaobiao" style="margin-left:4px;"></i> {{ $LANG('0957', '请购明细') }}</span>
                            </el-tab-pane>
                            <el-tab-pane  name="three"> 
                                <span slot="label"><i class="iconfont icon-wuliaoguanli1" style="margin-left:4px;"></i> {{ $LANG('0051', '投料明细') }}</span>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                    <el-dropdown @command="dropSel" size="mini" style="height:24px;font-size:12px;margin-top:1px; margin-left:20px; margin-right:15px">
                        <el-button type="danger" size="mini" style="height:26px">
                            {{ $LANG('0337', '更多') }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item icon="iconfont icon-daochu" command="expdata" style="line-height:40px;height:40px">{{ $LANG('0219', '导出请购汇总') }}</el-dropdown-item>
                            <el-dropdown-item icon="iconfont icon-daochu" command="expstk" style="line-height:40px;height:40px"> 导出请购汇总(仓库使用) </el-dropdown-item>
                            <el-dropdown-item icon="iconfont icon-daochu" command="expreq" style="line-height:40px;height:40px"> 导出当前请购明细 </el-dropdown-item>
                            <el-dropdown-item icon="iconfont icon-piliangbianji" command="notice" style="line-height:40px;height:40px">4M{{ $LANG('1079', '变更通知单') }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div style=" overflow:hidden;width:100%;height:100%;">
                    <div v-show="v_active=='one'" style="width:100%;height:100%;display:flex;flex-direction:column;overflow:hidden;">
                        <div style="line-height:28px;height:28px;margin-top:6px;color:black;font-weight:600;font-size:12px; background: #ccc;min-width:400px;display:flex;">
                            
                            <div style="width:110px; line-height:26px;height:26px;margin-left:2px" >
                                <el-button size="mini"  @click="nextPo" type="primary" ><div style="font-size:12px;margin-top:-4px "><i class="iconfont icon-caidanxiajiantou"></i>{{ $LANG('1048', '下推采购单') }} </div></el-button>
                            </div>    
                            <div style="min-width:80px; line-height:26px;height:26px;margin-left:25px" >
                                <el-button size="mini"  @click="batModify()" type="info" ><div style="font-size:12px;margin-top:-4px "><i class="iconfont icon-piliangbianji"></i>{{ $LANG('0049', '批改状态') }} </div></el-button>
                            </div>
                            <div style="min-width:80px; line-height:26px;height:26px;margin-left:25px" >
                                <el-button size="mini"  @click="batUnlock" type="danger" ><div style="font-size:12px;margin-top:-4px "><i class="iconfont icon-jiesuo"></i>{{ $LANG('2142', '释放锁库记录') }} </div></el-button>
                            </div>
                            <el-tooltip effect="light">
                                <div slot="content">
                                    {{ $LANG('2007', '未开始') }}：<span>{{ $LANG('0355', '灰色') }} |</span>
                                    {{ $LANG('2017', '进行中') }}：<span style="color:blue;margin-right:5px">{{ $LANG('0385', '蓝色') }} </span> |
                                    {{ $LANG('1974', '已完成') }}：<span style="color:green;margin-right:5px"> {{ $LANG('0379', '绿色') }} </span>|
                                    {{ $LANG('1440', '异常') }}：{{ $LANG('0347', '橙色') }} |
                                    {{ $LANG('0270', '加急') }}：<span style="color:red">{{ $LANG('0375', '红色') }}</span>
                                </div>
                                <el-link :underline="false" style="font-size:12px;font-weight:600;color:green"> <i class="iconfont icon-yuandianxiao" style="margin-top:4px;color:green;margin-left:10px"></i>{{ $LANG('2097', '行记录颜色说明') }}</el-link>
                            </el-tooltip>
                            <el-checkbox  v-model="v_isfin" @change="hideChg" true-label="Y" style="margin-left:20px;color:black" false-label="N">
                                <span style="font-size:12px;color:black">{{ $LANG('2022', '隐藏完成') }}</span>
                            </el-checkbox> 
                            <div style="width:110px; line-height:26px;height:26px;margin-left:25px" >
                                <el-button size="mini"  @click="userSet" type="warning" ><div style="font-size:12px;margin-top:-4px "><i class="iconfont icon-shezhi"></i>{{ $LANG('0683', '字段设置') }} </div></el-button>
                            </div>
                        </div>
                        <ve-table :columns="vueCol" 
                                :table-data="reqData" 
                                :columnHiddenOption="columnHiddenOption"
                                :style="{ height: tabOneHeight + 'px', width: '100%' }"
                                :border-around="true"
                                :border-x="true" 
                                :border-y="true" 
                                :fixed-header="true"
                                row-key-field-name="PKID"
                                :row-style-option="rowStyleOption"
                                :cell-style-option="cellStyleOption"
                                
                                :scroll-width="0"
                                :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                                :virtual-scroll-option="virtualScrollOption"
                                :column-width-resize-option="columnWidthResizeOption"
                                :cellSelectionOption="{enable: false,}"
                                :footer-data="footerSum"
                                id="mat_request"
                                ref="rightBottomTab"
                                :expand-option="expandOption"
                            >
                        </ve-table>
                    </div>
                    <div v-if="v_active=='two'" style="width:100%;height:100%;display:flex;flex-direction:column;overflow:hidden;">
                        
                        <ve-table :columns="itemCol" 
                                :table-data="itemData" 
                                :columnHiddenOption="itemColumnHiddenOption"
                                :style="{ height: tabTwoHeight + 'px', width: '100%', marginTop: '6px' }"
                                :border-around="true"
                                :border-x="true" 
                                :border-y="true" 
                                :fixed-header="true"
                                row-key-field-name="PKID"
                                :row-style-option="rowStyleOption"
                                :cell-style-option="cellStyleOption"
                                :max-height="reqHeight" 
                                :scroll-width="0"
                                :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                                :virtual-scroll-option="virtualScrollOption"
                                :column-width-resize-option="getColumnWidthResizeOption('item')"
                                :cellSelectionOption="{enable: false,}"
                                :footer-data="footerData"
                                id="req_item"
                                ref="tableRef2"
                            >
                        </ve-table>
                    </div>
                    <div v-if="v_active=='three'" style="width:100%;height:100%;display:flex;flex-direction:column;overflow:hidden;">
                        <div style="line-height:23px;height:23px;color:#f00;font-weight:600;font-size:12px;padding-left:6px; background: #ccc;min-width:1200px;display:flex;margin-top:6px; ">
                            {{ $LANG('2097', '行记录颜色说明') }}：{{ $LANG('1992', '已领料') }}：{{ $LANG('0385', '蓝色') }} ，{{ $LANG('2098', '有库存') }}：{{ $LANG('0379', '绿色') }}
                        </div>
                        <ve-table :columns="pckCol" 
                                :table-data="pckData" 
                                :columnHiddenOption="packColumnHiddenOption"
                                :style="{ height: tabThreeHeight + 'px', width: '100%' }"
                                :border-around="true"
                                :border-x="true" 
                                :border-y="true" 
                                :fixed-header="true"
                                row-key-field-name="PKSEQ"
                                :row-style-option="rowStyleOption"
                                :cell-style-option="cellStyleOption"
                                :max-height="pckHeight" 
                                :scroll-width="0"
                                :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                                :virtual-scroll-option="virtualScrollOption"
                                :column-width-resize-option="getColumnWidthResizeOption('pack')"
                                :cellSelectionOption="{enable: false,}"
                                :footer-data="footerPck"
                                id="pck_item"
                                ref="tableRef3"
                            >
                        </ve-table>
                    </div>
                </div>
            </div>
            <!-- 提示框 -->
            <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
                </div>
                <div style="line-height:30px;display:flex">
                    <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                    <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
                </div>
                <span slot="footer"  >
                    <el-button size="small" type="primary" @click="promptWin = false">{{ $LANG('1638', '确 定') }}</el-button>
                </span>
            </el-dialog>  
            <!-- 运算条件-->
            <el-dialog v-dialogDrag :visible.sync="condWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0982', '运算条件') }}</span>
                </div>
                <div style="line-height:35px;height:40px;font-size:12px;font-weight:600">
                    <el-checkbox :label="$LANG('0577', '使用库存')" true-label="Y" false-label="N" v-model="v_stk"></el-checkbox>
                </div>
                <div style="line-height:35px;height:40px;font-size:12px;font-weight:600">
                    <el-checkbox :label="$LANG('1306', '考虑安全库存')" true-label="Y" false-label="N" v-model="v_safe"></el-checkbox>
                </div>
                <div style="line-height:35px;height:40px;font-size:12px;font-weight:600">
                    <el-checkbox :label="$LANG('1407', '考虑废品、损耗')" true-label="Y" false-label="N" v-model="v_lost"></el-checkbox>
                </div>
                <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                    <span style="float:right">
                        <el-button type="info" icon="iconfont icon-shanchu" size="small"  @click="condWin=false" style="margin-right:50px;">{{ $LANG('0132', '取消') }}</el-button>
                        <el-button type="primary" icon="iconfont icon-yiqueren-xianxing"  size="small" @click="mrpSure" style="margin-right:12px;">{{ $LANG('1638', '确定') }}</el-button>
                    </span>
                </div>
            </el-dialog> 
            <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
                <el-image  src="/assets/authorize/loading.gif" ></el-image>  
            </el-dialog>
            <!-- 变更物料类型--> 
            <el-dialog v-dialogDrag :visible.sync="stfgWin"  width="350px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0647', '变更状态') }}</span>
                </div>
                <div style="line-height:40px;height:40px;font-size:12px;font-weight:600;display:flex">
                    <div style="font-size:12px;width:100px">{{ $LANG('0863', '物料状态') }}</div>
                    <el-select   v-model="v_stfg" :placeholder="$LANG('1664', '请选择')" size="medium" style="width:220px">
                       <span v-for="item in stfgArr" :key='item.key'>
                            <el-option :label="item.CNAME" :value="item.CNAME"  ></el-option>
                        </span>
                    </el-select>
                </div>
                <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                    <span style="float:right">
                        <el-button type="info" icon="iconfont icon-shanchu" size="small"  @click="stfgWin=false" style="margin-right:50px;">{{ $LANG('0132', '取消') }}</el-button>
                        <el-button type="primary" icon="iconfont icon-chenggong"  size="small" @click="stfgSure" style="margin-right:12px;">{{ $LANG('1638', '确定') }}</el-button>
                    </span>
                </div>
            </el-dialog>
            <!-- 变更物料类型--> 
            <el-dialog v-dialogDrag :visible.sync="propWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1214', '变更物料属性') }}</span>
                </div>
                <div style="line-height:35px;height:40px;font-size:12px;font-weight:600;display:flex">
                    <div style="font-size:12px;width:100px">{{ $LANG('0705', '层级主键') }}1</div>
                    <el-input size="small" disabled  v-model="v_idseq" style="width:320px"></el-input>
                </div>
                <div style="line-height:35px;height:40px;font-size:12px;font-weight:600;display:flex">
                    <div style="font-size:12px;width:100px">{{ $LANG('0705', '层级主键') }}2</div>
                    <el-input size="small" disabled  v-model="v_lstseq" style="width:320px"></el-input>
                </div>
                <div style="line-height:35px;height:40px;font-size:12px;font-weight:600;display:flex">
                    <div style="font-size:12px;width:100px">{{ $LANG('0380', '编码') }}</div>
                    <el-input size="small" disabled  v-model="v_matno" style="width:320px;background:#f7f8f9"></el-input>
                </div>
                <div style="line-height:35px;height:40px;font-size:12px;font-weight:600;display:flex">
                    <div style="font-size:12px;width:100px">{{ $LANG('0282', '名称') }}</div>
                    <el-input size="small" disabled  v-model="v_label" style="width:320px;background:#f7f8f9"></el-input>
                </div>
                <div style="line-height:35px;height:40px;font-size:12px;font-weight:600;display:flex">
                    <div style="font-size:12px;width:100px">{{ $LANG('0859', '物料属性') }}</div>
                    <el-select @change="propChg(v_prop)" v-model="v_prop" :placeholder="$LANG('1664', '请选择')" size="small" style="width:320px">
                       <el-option :label="$LANG('0382', '自制')" value="IN"></el-option>
                       <el-option :label="$LANG('0297', '委外')" value="OUT"></el-option>
                       <el-option :label="$LANG('0295', '外购')" value="PO"></el-option>
                       <el-option :label="$LANG('0300', '客供')" value="CLNT"></el-option>
                    </el-select>
                </div>
                <div style="line-height:35px;height:40px;font-size:12px;font-weight:600;display:flex">
                    <div style="font-size:12px;width:100px; ">{{ $LANG('1085', '委外供应商') }}</div>
                    <el-select v-model="v_supno" filterable :disabled="supFlag" :placeholder="$LANG('1664', '请选择')" size="small" style="width:320px">
                        <span v-for="(item,index) in supArr" :key="index">
                            <el-option :label="item.SUPNM" :value="item.IDSEQ"  ></el-option>
                        </span>
                    </el-select>
                </div>
                <div style="line-height:35px;height:40px;font-size:12px;font-weight:600;display:flex">
                    <div style="font-size:12px;width:100px">{{ $LANG('1203', '加工费用 / 件') }}</div>
 
                    <el-input disabled type="number" @keydown.native="e=>e.returnValue=(['e','E','+','-'].includes(e.key))?false:e.returnValue"     size="small"  :controls="false"  v-model="v_fee" style="width:320px"> </el-input> 
                </div>
                <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                    <span style="float:right">
                        <el-button type="info" icon="iconfont icon-shanchu" size="small"  @click="propWin=false" style="margin-right:50px;">{{ $LANG('0132', '取消') }}</el-button>
                        <el-button type="primary" icon="iconfont icon-yiqueren-xianxing"  size="small" @click="propSure" style="margin-right:12px;">{{ $LANG('1638', '确定') }}</el-button>
                    </span>
                </div>
            </el-dialog> 
            <!-- report preview -->
            <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
                </div> 
                <div style="height:88vh;overflow-y:auto">
                    <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
                </div>
            </el-dialog>
            <!-- 分配 QUANTITY-->
            <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="stkWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0554', '仓存明细') }}</span>
                </div> 
                <el-table  :data="stkData" 
                    border                            
                    disabled-hover
                    class="custom-table-border"
                    cell-class-name="clearPadding"
                    :cell-style="{padding:'2px'}"
                    style="overflow:auto;margin-top:1px;"
                    size="small"
                    ref="refstk"
                    :height="180" 
                    highlight-current-row>
                    <el-table-column :label="$LANG('0310', '序号')" width="50" fixed type="index"></el-table-column>
                    <el-table-column  v-for="(item,index ) in stkCol.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"  
                        :sortable="item.sortable=='N'"                                
                        :min-width="item.width">
                        <template slot="header">
                            <span v-if="item.notnull=='Y'" style="color:red">{{item.title}}</span>
                            <span v-else >{{item.title}}</span>
                        </template>
                        <template  slot-scope="scope" >
                            <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y" disabled false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                            <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+','-'].includes(e.key))?false:e.returnValue" @keyup.down.native="nextLine(item.key,'down')" @keyup.up.native="nextLine(item.key,'up')"   @keyup.enter.native="nextLine(item.key,'enter')"  size="mini" v-else-if="item.key=='ALLOQTY'" :controls="false"  v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                            <div v-else  >{{scope.row[item.key]}}</div>
                        </template>
                    </el-table-column>  
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="70">
                        <template slot-scope="scope">  
                            <i class="iconfont icon-lock" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link  @click="alloCate(scope.row  )" :underline="false"  ><span style="font-size:12px; ">{{ $LANG('0268', '分配') }}</span></el-link>
                        </template>
                    </el-table-column> 
                </el-table>
                <div class="one-toolbar">
                    <span class="spanRow" >{{ $LANG('1023', '锁库明细') }}</span>
                </div>
                <el-table  :data="lockData" 
                    border                            
                    disabled-hover
                    class="custom-table-border"
                    :cell-style="{padding:'2px'}"
                    style="overflow:auto;margin-top:1px;"
                    size="small"
                    ref="reflock"
                    :height="180" 
                    highlight-current-row>
                    <el-table-column :label="$LANG('0310', '序号')" width="50" type="index"></el-table-column>
                    <el-table-column  v-for="(item,index ) in lockCol.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"  
                        :sortable="item.sortable=='N'"                                
                        :min-width="item.width">
                        <template slot="header">
                            <span v-if="item.notnull=='Y'" style="color:red">{{item.title}}</span>
                            <span v-else >{{item.title}}</span>
                        </template>
                        <template  slot-scope="scope" >
                            <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y" disabled false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                            <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+','-'].includes(e.key))?false:e.returnValue" @keyup.down.native="nextLine(item.key,'down')" @keyup.up.native="nextLine(item.key,'up')"   @keyup.enter.native="nextLine(item.key,'enter')"  size="mini" v-else-if="item.key=='ALLOQTY'" :controls="false"  v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                            <div v-else  >{{scope.row[item.key]}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="70">
                        <template slot-scope="scope">  
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link  @click="delCate(scope.row,scope.$index  )" :underline="false"  ><span style="font-size:12px; ">{{ $LANG('0131', '删除') }}</span></el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </el-dialog>
            <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="modWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0646', '变更明细') }}</span>
                </div> 
                <el-table  :data="modData" 
                    border                            
                    size="small"
                    class="custom-table-border"
                    :cell-style="{padding:'2px'}"
                    :height="400" 
                    :row-key="getModKey"
                    ref="refreq"
                    highlight-current-row
                    style="overflow:auto;margin-top:1px;"> 
                    <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"></el-table-column>
                        <el-table-column   v-for="(item,index ) in modCol.filter(item=>item.thide=='N')" :key="index"
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                            :min-width="item.width">
                            <template slot-scope="scope">
                                <el-link v-if="item.key=='IDNO'" :underline="false" @click="nodShow(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;font-size:11px ">{{scope.row[item.key]}}</div> </el-link>
                                <el-checkbox v-else-if="item.edcss=='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                                <span v-else v-text="scope.row[item.key]" ></span>
                            </template>
                        </el-table-column>         
                </el-table>
            </el-dialog>
            <el-dialog  v-dialogDrag v-if="btnWin" :visible.sync="btnWin" :width="dtlWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0997', '选择记录') }}</span>
                </div> 
                <pub-win v-bind:tabCol ="pubCol" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
            </el-dialog>
            <!-- 请购明细 -->
            <el-dialog class="pub_dialog" v-dialogDrag v-if="reqWin" :visible.sync="reqWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0957', '请购明细') }}</span>
                </div> 
                <div style="height:80vh;overflow-y:auto">
                    <req-tmpl  @child-exit="reqWin=false" @child-sure="reqSure" v-bind:reqData="v_reqData"></req-tmpl>
                </div>

            </el-dialog>
            <el-dialog class="pub_dialog" v-dialogDrag  v-if="setWin" :visible.sync="setWin" width="480px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">字段显示设置</span>
                </div> 
                <easy-win v-bind:colArr ="fldArr" @child-exit="setRedo" @child-sure="setOk"></easy-win>
            </el-dialog> 
        </template>       
    </split-pane>
</template>

<script>
import pubWin from '../datamgt/pubwin.vue'
import easyWin from '../datamgt/easy_field.vue' 
import { getTabColOrData,getBaseData  } from '../../api/user'
import { getDate} from '../../api/Select' 
import reqTmpl from '../datamgt/req_tmpl.vue'
import extendTab from '../datamgt/extend_tab.vue' 
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
 
export default {
    name: "mat_request",
    mixins: [
        createVeTableFieldSettingMixin({
            grids: {
            
                item: {
                    settingFormId: '16572',
                    fieldIdseq: '16572',
                    fieldLstseq: '2100',
                    mainColumnKey: 'itemInitCol',
                    initColumnKey: 'itemInitCol',
                    tableColumnKey: 'itemCol',
                    tableRef: 'tableRef2',
                    columnHiddenOptionKey: 'itemColumnHiddenOption',
                    generatedFixedColumnKeys: ['rownum'],
                },
                pack: {
                    settingFormId: '16572',
                    fieldIdseq: '16572',
                    fieldLstseq: '2101',
                    mainColumnKey: 'pckInitCol',
                    initColumnKey: 'pckInitCol',
                    tableColumnKey: 'pckCol',
                    tableRef: 'tableRef3',
                    columnHiddenOptionKey: 'packColumnHiddenOption',
                    generatedFixedColumnKeys: ['rownum'],
                },
            },
        })
    ],
    data(){
        return {
            expandOption: {
                render: ({ row, column, rowIndex }, h) => {
                    return  <extendTab  tabCol ={this.tableCol} v_table="v_po_reqitm" v_key="idno" v_value={row['IDNO']} v_key2="matno" v_value2={row['MATNO']}></extendTab> 
                },
                afterExpandRowChange: ({ afterExpandedRowKeys, row, rowIndex }) => {
                    //alert("切换后的事件");
                },
            },
            columnWidthResizeOption: {
                enable: true, // default false
                minWidth: 20, // column resize min width
                sizeChange: ({ column, differWidth, columnWidth }) => {
                    const targetCol =this.vueCol.find(item=>item.key==column.key)
                    if (targetCol){
                        targetCol.width =columnWidth
                    }
                },
            },
            v_table:'',
            v_key2:'',
            v_value2:'',
            t_loading:false,
            v_fee:'',
            stfgWin:false,
            v_stfg:'',
            repWin:false,
            repUrl:'',
            modData:[],
            expkeys:[],
            modWin:false,
            stkWin:false,
            supFlag:true,
            v_supno:'',
            supArr:[],
            setWin:false,
            v_supnm:'',
            reqData:[],
            v_type:'',
            v_select:[],
            v_stk:'N',  //使用库存
            v_safe:'N', //考虑安全库存
            v_lost:'N', //考虑废品、损耗
            v_sup:'N', //推荐采购供应商
            condWin:false,
            ordArr:[],
            ordData:[],
            selparam:'N',
            actitem:0,
            v_active:'one',
            reqWin:false,
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            mapData:[],
            originData:[],
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            v_usernm:this.$cookies.get('v_usernm'),  
            operArr:[],
            stkCol:[],
            stkData:[],
            lockCol:[],
            lockData:[],
            itemData:[],
            v_matno:'',
            v_label:'',
            tyArr:[],
            tableCol:[],
            pubCol:[],
            promptWin:false,
            prompt:'',
            selData:[],
            treeData:[],
            btnWin:false,
            loadWin:false,
            v_loading:false,
            mrpData:[],
            itemCol:[],
            input_hold:this.$LANG('1670', '请输入内容...'),
            matData:[],
            dataCount:0,
            current:1,
            rowSize:50,
            loading:false, 
            v_reqrow:{},
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            v_isfin:'Y',
            v_reqData:[],
            treeCol: [],
            v_idseq:'',
            v_lstseq:'',
            v_prop:'',
            propWin:false,
            v_poRow:{},
            p_idseq:'',
            p_lstseq:'',
            taskCol:[] ,
            taskData:[],
            r_lstseq:'',
            outData:[],
            t_idseq:'',
            t_lstseq:'',
            v_ordseq:'',
            v_row:{},
            v_lockRec:{},
            modCol:[],
            saveFlag:false,
            stfgArr:[],
            topTableHeight: 200, // 上方表格初始高度，和你原来写的200一致
            isResizing: false,
            startY: 0,
            startTopHeight: 200,

            rightTopHeight: 150, // 右边上方表格初始高度，和你原来右边的固定高度一致即可
            rightIsResizing: false,
            rightStartY: 0,
            rightStartTopHeight: 150,
            tabOneHeight: 0,
            tabTwoHeight: 0,
            tabThreeHeight: 0,    
            footerData:[], 
            footerSum:[],
            footerPck:[],
            columnHiddenOption: {
                defaultHiddenColumnKeys: [],
            },
            itemColumnHiddenOption: {
                defaultHiddenColumnKeys: [],
            },
            packColumnHiddenOption: {
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: {
                clickHighlight: true,                
            },
            virtualScrollOption: { enable: false },
            cellStyleOption: {
                bodyCellClass: ({ row, column, rowIndex }) => {
                    if (row['POSTFG']=='未开始' ){
                        return 'table-body-cell-class1'
                    }else if (row['POSTFG']=='进行中' ){
                        return 'table-body-cell-blue'
                    }else if (row['POSTFG']=='已完成' ){
                        return 'table-body-cell-green'
                    }else if (row['POSTFG']=='异常' ){
                        return 'table-body-cell-yellow'
                    } else if (row['POSTFG']=='加急' ){
                        return 'table-body-cell-red'
                    }else if (row['ISSTK']=='Y'){
                        return "table-body-cell-blue"
                    }else if (row['ISWH']=='Y'){
                        return "table-body-cell-green"
                    }else{
                        return "table-body-cell-class1"
                    }                      
                },
                headerCellClass: ({column, rowIndex }) => {
                    if (column.notnull=='Y'){
                        return "table-head-cell-class2" 
                    }else{
                        return "table-head-cell-class" 
                    }
                },
                footerCellClass: ({ row, column, rowIndex }) => {
                    return "table-foot-cell-class";
                },
            },
            v_inputrow:{},
            loadingInstance: null,
            pckInstance: null,
            v_sort:'asc',
            startRowIndex: 0,
            vueCol:[],
            fldArr:[], 
            v_selAll:'N',
            pckData:[],
            pckCol:[],
            itemInitCol:[],
            pckInitCol:[],
            e_row:{},
            empCol:[],
 
        }
    },
    destroyed() {
        this.loadingInstance.destroy()
        this.pckInstance.destroy()
    },
    beforeDestroy() {
        // 组件销毁时解绑全局事件，防止内存泄漏
        window.removeEventListener('resize', this.handleTableResize)
        document.removeEventListener('mousemove', this.onVerticalResizeMove, true)
        document.removeEventListener('mouseup', this.onVerticalResizeEnd, true)
        // 新增：右边事件解绑，防止内存泄漏
        document.removeEventListener('mousemove', this.onRightResizeMove, true)
        document.removeEventListener('mouseup', this.onRightResizeEnd, true)
    },
    created(){
        this.loadingInstance = this.$veLoading({
            target: document.querySelector("#mat_request"),
            name: "wave",
        })
        this.pckInstance = this.$veLoading({
            target: document.querySelector("#pck_item"),
            name: "wave",
        })
        //初始化
        this.getTabField()
        this.inputQry()
   
    },
    mounted(){
        //供应商(委外加工类型)
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'supty','399986','v_bs_sup','').then(res=>{
            this.supArr =res.result
        })
        //操作符
        getBaseData('xuper_auth/getTableRecMany','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        getBaseData('xuper_auth/getTableRecMany','PARENTNO','436971','','','v_sys_base','').then(res=>{
            this.stfgArr =res.result
        })
        
        getBaseData('xuper_auth/getTableRecMany','PARENTNO','398538','','','v_sys_base','').then(res=>{
            this.tyArr =res.result
        })
        //用户表单新增、编辑、审核、作废权限  
        getBaseData(this.v_url,'userno',this.v_username ,'frmidseq','16572','v_sys_user_priv',' and issel=\'Y\'').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                if (res.result.length>0){
                    let row =res.result[0]
                    if (row.ISADD==='N'){ //新增
                        this.addBool=true
                    }if (row.ISUPD==='N'){ //修改
                        this.editBool=true
                    } if (row.ISCFM==='N'){ //审核
                        this.cfmBool=true
                    }if (row.ISCANCEL==='N'){ //作废
                        this.cancelBool=true
                    }
                }
            }
        }) 
        // 页面加载完成后，自动计算下方表格高度，适配面板大小
        this.$nextTick(() => {
            this.$refs.tabref.doLayout()
            this.$refs.reftree.doLayout()
            // 新增：右边表格初始化
            this.$refs.rightTopTab.doLayout()
            this.calcRightTableHeight()
     
        })
        // 窗口大小变化时自动重绘表格，避免错位
        window.addEventListener('resize', this.handleTableResize)
    },
    computed:{
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        }, 
        pckHeight(){
            return (window.innerHeight - 318) + 'px';
        },  
 
        subHeight(){
            return (window.innerHeight - 325) + 'px';
        },  
        reqHeight(){
            return (window.innerHeight - 295) + 'px';
        }, 
        dtlWidth: function() {
            return (window.innerWidth - 200) + 'px';
        },     
    },
    watch:{
        
    },
    components: {
       pubWin,
       reqTmpl,
       easyWin,
 
    },
    methods:{
        calcRightTableHeight() {
            // 获取右边最外层容器的总高度
            const rightContainer = this.$refs.rightTopWrap.parentElement
            if (!rightContainer) return
            
            // 计算所有固定元素的总高度：顶部标题栏30px + 上方表格高度 + 拖拽条8px + tab栏28px
            const fixedTotalHeight = 30 + this.rightTopHeight + 8 + 28
            // 剩余可用总高度，额外加20px安全余量，避免最后2条被截断
            const remainingHeight = rightContainer.clientHeight - fixedTotalHeight + 10

            // 分别给三个tab的ve-table赋值精准高度
            this.tabOneHeight = remainingHeight - 75 // 扣除请购汇总顶部按钮栏的28px+6px margin
            this.tabTwoHeight = remainingHeight - 45  // 扣除请购明细顶部6px margin
            this.tabThreeHeight = remainingHeight - 339 // 扣除投料明细顶部颜色说明栏23px+6px margin
        },
        startRightResize(e) {
            this.rightIsResizing = true
            this.rightStartY = e.clientY
            this.rightStartTopHeight = this.rightTopHeight
            
            // 全局捕获事件，鼠标拖出区域也不失效
            document.addEventListener('mousemove', this.onRightResizeMove, true)
            document.addEventListener('mouseup', this.onRightResizeEnd, true)
            document.body.style.userSelect = 'none'
            e.preventDefault()
        },
        // 右边拖拽过程中实时更新高度
        onRightResizeMove(e) {
            if (!this.rightIsResizing) return
            const offsetY = e.clientY - this.rightStartY
            let newHeight = this.rightStartTopHeight + offsetY
            
            // 高度边界限制：上方表格最小80px，给下方至少留150px高度
            const containerHeight = this.$refs.rightTopWrap.parentElement.clientHeight
            const maxTopHeight = containerHeight - 150
            newHeight = Math.max(80, Math.min(newHeight, maxTopHeight))
            
            this.rightTopHeight = newHeight
            this.calcRightTableHeight()
            // 实时刷新右边两个表格布局，防止错位
            this.$nextTick(() => {
                this.$refs.rightTopTab && this.$refs.rightTopTab.doLayout()
                
            })
        },
        // 右边拖拽结束
        onRightResizeEnd() {
            this.rightIsResizing = false
            document.removeEventListener('mousemove', this.onRightResizeMove, true)
            document.removeEventListener('mouseup', this.onRightResizeEnd, true)
            document.body.style.userSelect = 'auto'
            // 拖拽结束后重新计算精准高度
            this.calcRightTableHeight()
          
        },
         //左边 开始拖拽
        startVerticalResize(e) {
            this.isResizing = true
            this.startY = e.clientY
            this.startTopHeight = this.topTableHeight
            
            // 全局捕获事件，鼠标拖到页面外也不会失效
            document.addEventListener('mousemove', this.onVerticalResizeMove, true)
            document.addEventListener('mouseup', this.onVerticalResizeEnd, true)
            document.body.style.userSelect = 'none'
            e.preventDefault()
        },
        // 拖拽中实时更新高度
        onVerticalResizeMove(e) {
            if (!this.isResizing) return
            const offsetY = e.clientY - this.startY
            let newHeight = this.startTopHeight + offsetY
            
            // 高度边界限制：上方表格最小80px，最大不超过面板高度的70%（防止下方表格完全看不见）
            const containerHeight = this.$refs.topTableWrap.parentElement.clientHeight
            const maxTopHeight = containerHeight - 150 // 给下方BOM表至少留150px高度
            newHeight = Math.max(80, Math.min(newHeight, maxTopHeight))
            
            this.topTableHeight = newHeight
            
            // 实时刷新表格布局，解决Element表格高度不更新的bug
            this.$nextTick(() => {
                this.$refs.tabref.doLayout()
                this.$refs.reftree.doLayout()
            })
        },
        // 拖拽结束
        onVerticalResizeEnd() {
            this.isResizing = false
            document.removeEventListener('mousemove', this.onVerticalResizeMove, true)
            document.removeEventListener('mouseup', this.onVerticalResizeEnd, true)
            document.body.style.userSelect = 'auto'
        },
        // 窗口大小变化时重绘
        handleTableResize() {
            this.$nextTick(() => {
                this.$refs.tabref.doLayout()
                this.$refs.reftree.doLayout()
                // 新增：右边重绘
                this.calcRightTableHeight()
                this.$refs.rightTopTab && this.$refs.rightTopTab.doLayout()
           
       
            })
        },       
        // 字段设置
        userSet(){
            this.fldArr =[]
            getTabColOrData(this.v_url ,'V_USER_FLDSET','idseq','16572-2097','userno',this.v_username,'','',' order by sortby').then((res) => {
                let v_setArr =res.result
                //预处理：将 v_setArr中所有的FLDNO提取出来，转为大写，存入 Set
                const existFldnos =new Set()
                v_setArr.forEach(item=>existFldnos.add(item.FLDNO.toUpperCase()))
                // 遍历 vueCol, 检查是否存在
                this.vueCol.forEach(item =>{
                    const keyUpper = (item.key||'').toUpperCase()
                    if (!existFldnos.has(keyUpper)){
                        let v_obj ={'IDSEQ':'16572-2097',LSTSEQ:'',COLWIDTH:item.width,CORPID:this.v_corpid,USERNO:this.v_username,FLDNO:item.key,FLDNM:item.title, 'VISFLAG':'Y'}
                        v_setArr.push(v_obj)
                        // 同时也添加到 Set 中，防止 vueCol 中有重复的 key 导致重复添加
                        existFldnos.add(keyUpper)
                    }
                })
                //构建Map,源数组 : key ---> COLWIDTH
                const widthMap =new Map(this.vueCol.map(item=>[item.key,item.width])) 
                //遍历目标数组并更新
                let updateColumns =v_setArr.map(col =>{
                    if (widthMap.has(col.FLDNO)){
                        return {...col ,COLWIDTH:widthMap.get(col.FLDNO)}
                    }
                    return col
                })
                this.fldArr =[...updateColumns]
            })
            this.setWin =true  
        },
        getSetList(){
            getTabColOrData(this.v_url, 'V_USER_FLDSET','idseq','16572-2097','userno',this.v_username,'','',' order by sortby').then((res) => {
                let v_data =res.result 
                if (v_data && v_data.length>0) { // 有用户个性化记录
                    let v_arr=[]
                    this.columnHiddenOption['defaultHiddenColumnKeys'] =[]
                    // 1、隐藏 ，2、列宽 3、排序
                    v_data.forEach(item=>{
                        if (item['VISFLAG'] =='N') {
                            this.columnHiddenOption['defaultHiddenColumnKeys'].push(item['FLDNO'])
                        }else{
                            v_arr.push(item['FLDNO'])
                        }
                    }) 
                    this.$refs["rightBottomTab"].showColumnsByKeys(v_arr)
                    this.$refs["rightBottomTab"].hideColumnsByKeys(this.columnHiddenOption['defaultHiddenColumnKeys'])
                    //1.1 构建 Map : key -> {width,sortby,isfix} ,使用 Map 提高查找效率
                    const configMap =new Map() //建立索引映射 
                    v_data.forEach(item =>{
                        configMap.set(item['FLDNO'],{COLWIDTH:item.COLWIDTH,SORTBY:item.SORTBY,ISFIX:item['ISFIX']})
                    })
                    //console.log(JSON.stringify(configMap))
                    //1.2 遍历 vueCol ,同步 width 宽度 与 冻结 fixed
                    this.vueCol.forEach(col =>{
                        const  targetCol= configMap.get(col['key'])
                        if (targetCol){
                            col.width =targetCol['COLWIDTH']
                            col.fixed =targetCol['ISFIX']=='Y'?"left":targetCol['ISFIX']=='R'?"right":false
                        }
                    })
                    //1.3 根据个性化的 SORTBY排序 来更新
                    this.vueCol.sort((a,b)=>{
                        const targetA =configMap.get(a['key'])
                        const targetB =configMap.get(b['key'])
                        const sortA = (targetA  && targetA.SORTBY!==undefined)?targetA.SORTBY:9999
                        const sortB = (targetB  && targetB.SORTBY!==undefined)?targetB.SORTBY:9999
                        return sortA - sortB
                    })
                }
            })
        }, 
        setOk(v_obj){  
            v_obj.forEach((item,index)=>item['SORTBY']=index+1)
            this.loadWin =true
            this.$axios({   
                method: 'post',
                url: 'xuper_auth/batDtlSave2' ,
                data: {p_json:JSON.stringify(v_obj), p_table:'USER_FLDSET',p_idseq:'16572-2097', p_action:'S' },
            }).then(res=>{
                if (res.code=='200') {
                    this.getSetList()
                    this.setWin =false
                    this.loadWin =false
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                    this.loadWin =false
                }
            })
        },
        setRedo(){  
            this.$confirm('你确定要恢复默认设置吗,确定后请重新打开此界面','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                this.loadWin =true
                this.$axios({   
                    method: 'post',
                    url: 'auth/delTabRec?username='+this.v_username +'&password='+this.v_password,
                    data: {p_key:'idseq',p_value:'16572-2097',p_key2:'userno',p_value2:this.v_username, p_table:'USER_FLDSET' },
                }).then(res=>{
                    if (res.code=='200') {
                        this.setWin =false
                        this.loadWin =false
                    }else{
                        this.promptWin =true
                        this.prompt =res.result
                        this.loadWin =false
                    }
                })
            }).catch(err=>{})
        },
        chgQry(){
            if (this.v_select.length==0){
                this.ordData =this.originData
            }else{
                this.ordData =this.originData.filter(item=>this.v_select.includes(item['IDNO'])) 
            }
        },
        //下推采购订单
        nextPo(){
            if (this.reqData.filter(item=>item.SEL=='Y').length==0){
                this.promptWin =true
                this.prompt =this.$LANG('1757', '请选择请购单记录')
            }else{
                this.v_reqData=this.reqData.filter(item=>item.SEL=='Y').map(req=>Object.assign(req,{SEL:'N'}))
                this.reqWin =true
                this.v_inputrow['SEL']='N'
            }
        },
        reqSure(v_obj){
            if (v_obj =='200'){
                this.$notify({
                    title: this.$LANG('1441', '成功'),
                    message: this.$LANG('1486', '已成功下推生成采购单'),
                    type: 'success'
                })
                this.reqWin =false
                this.getReqData(this.p_idseq ,'')
            }else{
                this.$notify({ title: this.$LANG('1446', '失败'), message: this.$LANG('1446', '下推失败！'),type: 'fail' })
                this.reqWin =false
            }
        },
        btnSure(obj){
            let v_cond=' set staff=\''+obj['EMPNM']+'\''
            this.$axios({
                method: 'post',
                url:'xuper_auth/updateRec',
                data: {p_table:'PO_REQDTL',p_key:'idseq',p_value:this.e_row['IDSEQ'],p_key2:'lstseq',p_value2:this.e_row['LSTSEQ'],p_cond: v_cond},
            }).then(res=>{ 
                this.enterDown()
                this.btnWin =false
            })
        },
        //批量下推 投料单
        nextGen(){
            let v_data =this.taskData.filter(item=>item['SEL']=='Y')
            if (v_data.length==0 ){
                this.promptWin =true
                this.prompt =this.$LANG('1701', '请选择行记录')
            }else{
                this.$confirm(this.$LANG('1629', '你确定要下推选中的任务单生成投料记录吗'),this.$LANG('1442', '提示'),{
                    confirmButtonText: this.$LANG('1638', '确定'),
                    cancelButtonText:this.$LANG('0132', '取消'),
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(async ()=>{
                    this.loadWin =true
                    const v_promises= v_data.map(item=>{
                        this.$axios({   
                            method: 'post',
                            url:'xuper_auth/getBaseData',
                            data: { p_key:'idseq',p_value:item['IDSEQ'], p_table:'V_pc_taskdtl'},
                        }).then(res=>{ 
                            let v_action=''
                            if (item['BILLTY']=='IN'){
                                v_action ='PRDDOWN'+this.v_username+'-'+item['IDSEQ']
                            }else{
                                v_action ='PRDNEXT'+this.v_username+'-'+item['IDSEQ']
                            }
                            
                            let v_json =JSON.stringify(res.result)
                            this.$axios({   
                                method: 'post',
                                url: 'xuper_auth/next_genpay',
                                data: { corpid:this.v_corpid,p_json: v_json,p_user: this.v_username,p_action:v_action},
                            }) 
                        })                        
                    })
                    try{
                        const v_times= await Promise.all(v_promises)                    
                        this.$message.success(this.$LANG('1457', '已成功下推完成:') +v_times+this.$LANG('0027', ' 张投料单') )
                        this.loadWin =false
                        //if (v_times.length ==v_data.length){        
                            setTimeout(() => {
                            this.getTaskList(this.v_ordseq) 
                            }, 1000);                  
                        //}
                    }catch(err){
                        this.promptWin =true
                        this.prompt =this.$LANG('1446', '下推失败：') +err
                    }
                }).catch((error)=>{})
            }
        },
        selChg(){
            this.taskData.filter(item=>item['ISPICK']=='N').forEach((item,index)=>{
               item['SEL'] =this.v_selAll
            })
        },
        reqChg(val){

            this.reqData.filter(item=>item['STFG']=='Y').forEach((item,index)=>{
               item['SEL'] =val
            })
        },
        getReqSum(){
            //累计数组中 接办数量的和
            let v_ttlqty =this.reqData.reduce((prev,cur)=>{
                let v_qty =cur.REQQTY ||0 
                return Number(prev) + Number(v_qty) },0)
            // footer data
            this.footerSum =[
                {
                    rowKey: 0,
                    index: this.$LANG('0280', '合计'),
                    REQQTY: v_ttlqty?v_ttlqty.toLocaleString():'',
                },
            ]
        } ,
        getFootSum(){
            //累计数组中 接办数量的和
            let v_ttlqty =this.itemData.reduce((prev,cur)=>{
                let v_qty =cur.REQQTY ||0 
                return Number(prev) + Number(v_qty) },0)
            // footer data
            this.footerData =[
                {
                    rowKey: 0,
                    index: this.$LANG('0280', '合计'),
                    REQQTY: v_ttlqty?v_ttlqty.toLocaleString():'',
                },
            ]
        } , 
        getPckSum(){
            //累计数组中 接办数量的和
            let v_ttlqty =this.pckData.reduce((prev,cur)=>{
                let v_qty =cur.QTY ||0 
                return Number(prev) + Number(v_qty) },0)
            let v_actqty =this.pckData.reduce((prev,cur)=>{
                let v_actqty =cur.ACTQTY ||0 
                return Number(prev) + Number(v_actqty) },0)
            // footer data
            this.footerPck =[
                {
                    rowKey: 0,
                    index: this.$LANG('0280', '合计'),
                    QTY: v_ttlqty?v_ttlqty.toLocaleString():'',
                    ACTQTY: v_actqty?v_actqty.toLocaleString():'',
                },
            ]
        } , 
        tabClick(val){
            this.v_active =val
            const configKey = { one: 'summary', two: 'item', three: 'pack' }[val]
            this.$nextTick(() => this.applyRuntimeColumnVisible(configKey))
            this.$nextTick(() => {
                this.calcRightTableHeight()
    
            })
        },
        expReqList(){
            this.loadWin =true   
            //导出
            this.$axios({
                method: 'post',
                url:'xuper_auth/report/GenExcel',
                data: {p_idseq:'16572',p_lstseq:'2100',p_json:JSON.stringify(this.itemData),p_action:'请购明细'},
                responseType:'blob' //关键，声明响应类型为二进制流
            }).then(response=>{ 
                // 从响应头解析后端设置的文件名
                // 创建Blob对象并触发下载  创建下载链接
                const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob)
                link.download =  '请购明细'+'_'+getDate('full')+'.xls'
                link.click()
                URL.revokeObjectURL(link.href)
                this.loadWin =false
            }) 
        },
        expOrdList(){
            this.loadWin =true   
            //导出
            this.$axios({
                method: 'post',
                url:'xuper_auth/report/GenExcel',
                data: {p_idseq:'16572',p_lstseq:'2088',p_json:JSON.stringify(this.ordData),p_action:'订单资料'},
                responseType:'blob' //关键，声明响应类型为二进制流
            }).then(response=>{ 
                // 从响应头解析后端设置的文件名
                // 创建Blob对象并触发下载  创建下载链接
                const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob)
                link.download =  '订单资料'+'_'+getDate('full')+'.xls'
                link.click()
                URL.revokeObjectURL(link.href)
                this.loadWin =false
            }) 
        },
        dropSel(val){
            if (val=='expdata'){
                this.repWin =true
                this.repUrl =this.$store.state.repUrl+ 'mat_status.cpt'+'&p_ordseq='+this.p_idseq
            }else if (val=='notice'){
                this.modNotice() 
            }else if (val=='expreq'){
                this.expReqList()
            }else if (val=='expstk'){
                this.loadWin =true   
                //导出
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/report/GenExcel',
                    data: {p_idseq:'16572',p_lstseq:'2104',p_json:JSON.stringify(this.reqData),p_action:'请购汇总(仓库)'},
                    responseType:'blob' //关键，声明响应类型为二进制流
                }).then(response=>{ 
                    // 从响应头解析后端设置的文件名
                    // 创建Blob对象并触发下载  创建下载链接
                    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob)
                    link.download =  '请购汇总(仓库)'+'_'+getDate('full')+'.xls'
                    link.click()
                    URL.revokeObjectURL(link.href)
                    this.loadWin =false
                }) 
            }
        },

        editRec(row,index,val){
        },
        //合并表 单元格
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if ( column.property=='IDNO' ||column.property=='OPER'   ) { //||column.property=='ORDDTTM'
                // 获取当前单元格的值
                const currentValue = row[column.property]
                const currIdno = row['IDNO'];
                // 获取上一行相同列的值
                const preRow = this.ordData[rowIndex - 1];
                const preValue = preRow ? preRow[column.property] : null;
                const preIdno = preRow ? preRow['IDNO'] : null;
                // 如果当前值和上一行的值相同，则将当前单元格隐藏
                if (currentValue === preValue && column.property=='IDNO') {
                    return { rowspan: 0, colspan: 0 }
                }else if (currentValue === preValue && currIdno ==preIdno && column.property=='OPER') {
                    return { rowspan: 0, colspan: 0 }
                }
                // else if (currentValue === preValue && currIdno ==preIdno && column.property=='ORDDTTM') {
                //     return { rowspan: 0, colspan: 0 }
                // } 
                else {
                    // 否则计算当前单元格应该跨越多少行
                    let rowspan = 1
                    for (let i = rowIndex + 1; i < this.ordData.length; i++) {
                        const nextRow = this.ordData[i];
                        const nextValue = nextRow[column.property]
                        const nextIdno = nextRow['IDNO']
                        if (nextValue === currentValue && column.property=='IDNO') {
                            rowspan++;
                        }else if (nextValue === currentValue && currIdno ==nextIdno && column.property=='OPER') {
                            rowspan++;
                        } else {
                            break;
                        }
                    }
                    return { rowspan, colspan: 1 };
                }
            }
        },
        //树状BOM
        getBomList(v_idseq){
            this.t_loading =true
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getMrpTreeData',
                data: {p_key:'idseq',p_value:v_idseq,p_table:'V_MRP_DTL_MATNO',p_cond: ' order by pkid' },
            }).then(res=>{ 
                if (res.code==='200'){
                    this.treeData =res.result
                    if (this.treeData.length>0){
                        this.$nextTick(() => { //有固定列时 查询后重新布局
                            this.$refs['reftree'].setCurrentRow(this.treeData[0])
    
                            this.expkeys=[this.treeData[0]['usetool']]
                            this.t_loading =false
                        })
                    }
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }   
            }) 
        },
        //请购单审核
        stfgRec(){
            if ( Object.keys(this.v_poRow).length>0){
                //this.$message.success('请购单号：'+this.v_poRow['IDNO'])
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: { p_key:'idSEQ',p_value:this.v_poRow['IDSEQ'],p_key2:'stfg',p_value2:'Y', p_table:'v_po_req'},
                }).then(res=>{ 
                    if (res.result.length>0){
                        this.promptWin =true
                        this.prompt =this.$LANG('1542', '此记录已是审核状态')+'：'+this.v_poRow['IDNO']
                    }else{
                        let v_cond=' set stfg=\'Y\',chkuser=\''+this.v_usernm+'\',chkdttm=\''+getDate('full')+'\''
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/updateRec',
                            data: {p_table:'PO_REQ',p_key:'idseq',p_value:this.v_poRow['IDSEQ'], p_cond: v_cond},
                        }).then(res=>{ 
                            this.getReqData(this.p_idseq ,'')
                            //this.reqData.splice(index,1,Object.assign(item,{SEL:'N',POSTFG:this.v_stfg}))
                        })
                    }
                })
                
            }else{
                this.$message.error(this.$LANG('1563', '没有请购记录'))
            }
        },
        // 成品切换
        itemClick(val,item){
            this.actitem =val     
            this.t_idseq = item['IDSEQ']
            this.t_lstseq = item['LSTSEQ']
            this.treeData =[]
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'refidseq',p_value:this.t_idseq,p_key2:'reflstseq',p_value2:this.t_lstseq,p_table:'V_mrp'},
            }).then(res=>{ 
                if (res.result.length >0)
                this.getBomList(res.result[0]['IDSEQ'])
            })
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.inputQry()
        } ,
        repShow(row,val){
            if (val=='PONO'){
                this.repWin =true
                this.repUrl =this.$store.state.repUrl+ 'rep_poord.cpt'+'&p_corpid='+this.v_corpid+'&p_idno='+row['PONO'] 
            }else if (val=='REQNO'){
                this.repWin =true
                this.repUrl =this.$store.state.repUrl+ 'po_req.cpt'+'&p_corpid='+this.v_corpid+'&p_idno='+row['IDNO'] 
            }
        },
        //释放锁库记录
        batUnlock(){
            const v_len =this.reqData.filter(item=>item['SEL']=='Y').filter(item=>item['LOCKQTY']&&item['LOCKQTY']>0)
            if (v_len.length==0){
                this.promptWin =true
                this.prompt =this.$LANG('2143', '请勾选要释放锁库的记录')
                return
            }else{
                const v_bool =v_len.some(item=>item['PONO']&&item['PONO']!='')
                // if (v_bool){
                //     this.promptWin =true
                //     this.prompt =this.$LANG('2144', '存在有下推采购订单的记录,不能释放锁库')
                //     return
                // }
                this.$confirm(this.$LANG('2145', '你确定要释放选中的锁库记录吗'),this.$LANG('1442', '提示'),{
                    confirmButtonText: this.$LANG('1638', '确定'),
                    cancelButtonText:this.$LANG('0132', '取消'),
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(async (res)=>{
                    this.loadWin =true
                     let promises =v_len.map(item=>{
                        return this.$axios({   
                            method: 'post',
                            url: 'xuper_auth/delTabRec',
                            data: {p_key:'reqseq',p_value:item['IDSEQ'],p_key2:'reqitm',p_value2:item['LSTSEQ'],p_key3:'matno',p_value3:item['MATNO'], p_table:'IC_STKLOG_DTL' },
                        })
                    })
                    await Promise.all(promises).then((res) => {
                        this.getReqList(this.p_idseq)
                        this.loadWin =false
                    })
                }).catch((error)=>{})
            }
        },
        //批改
        batModify(){
            let v_bool =false
            this.reqData.some(item =>{
                if (item['SEL']=='Y'){
                    v_bool =true
                }
            })
            if (v_bool){
                this.stfgWin =true
            }else {
               this.promptWin =true
               this.prompt =this.$LANG('0792', '请勾选要变更的记录')
            }
        },
        //确定变更状态
        stfgSure(){
            if (this.v_stfg){
                let k =0
                this.reqData.forEach((item,index) =>{
                    k++
                    if (item['SEL']=='Y'){
                        let v_cond =' set postfg=\''+this.v_stfg+'\',stfgdttm=\''+getDate('full')+'\',stfguser=\''+this.v_usernm+'\''
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/updateRec',
                            data: {p_table:'PO_REQDTL',p_key:'idseq',p_value:item['IDSEQ'],p_key2:'lstseq',p_value2:item['LSTSEQ'],p_cond: v_cond},
                        }).then(res=>{ 
                            this.reqData.splice(index,1,Object.assign(item,{SEL:'N',POSTFG:this.v_stfg}))
                        })
                    }
                    if (k ==this.reqData.length){
                        this.stfgWin =false
                    }
                })
            }else{
                this.promptWin =true
                this.prompt =this.$LANG('1729', '请选择变更状态')
            }
        },
        //变更通知明细
        modNotice(){
            this.modWin =true
            let v_cond=''
            this.matData.forEach(item=>{
                if (v_cond==''){
                    v_cond ='\''+item['MATNO']+'\''
                }else{
                    v_cond =v_cond+','+ '\''+item['MATNO']+'\''  
                }
            })
            this.getChgList(v_cond)
        },
        //4M变更单
        getChgList(v_cond){
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'corpid', p_value:this.v_corpid,p_cond:' and MATNO in ('+v_cond+')',p_table:'v_qc_chg'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.modData =res.result
                }else{
                    this.promptWin=true
                    this.prompt=res.code+':'+res.result
                }
            }) 
        },
        //生产任务单
        getTaskList(v_idseq){
 
            this.taskData =[]
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key2:'corpid', p_value2:this.v_corpid,p_key:'ordseq',p_value:v_idseq,p_table:'V_pc_task'},
            }).then(res=>{ 
                if (res.code==='200'){
                    res.result.forEach(item=>{
                        this.taskData.push(Object.assign(item,{IDTY:'自制',BILLTY:'IN' }))
                    })
                    // 委外加工单
                    this.$axios({   
                        method: 'post',
                        url:'xuper_auth/getBaseData',
                        data: { p_key2:'corpid', p_value2:this.v_corpid,p_key:'ordseq',p_value:v_idseq,  p_table:'V_pc_out'},
                    }).then(res=>{ 
                        res.result.forEach(item=>{
                            this.taskData.push(Object.assign(item,{IDTY:'委外',BILLTY:'OUT' }))
                        })
                        this.$refs['rightTopTab'].doLayout()
                    })    
                }else{
                    this.promptWin=true
                    this.prompt=res.code+':'+res.result
                }
            }) 
        },
 
        propChg(val){
            this.v_supno =''
            if (val =='OUT'){ //委外
                this.supFlag =false
            }else{
                this.supFlag =true
            }
        },
 
        nodShow(row){
            this.repWin =true
            this.repUrl =this.$store.state.repUrl+ row['REPURL']+'&p_corpid='+this.v_corpid+'&p_idno='+row['IDNO']
        },
  
        ordShow(row){
            this.repWin =true
            this.repUrl =this.$store.state.repUrl+ row['REPURL']+'&p_corpid='+this.v_corpid+'&p_idno='+row['IDNO']
        },
 
        taskShow(row,val){
            this.repWin =true
            if (val =='IN'){
                this.repUrl =this.$store.state.repUrl+ row['REPURL']+'&p_corpid='+this.v_corpid+'&p_idno='+row['IDNO']
            }else{
                this.repUrl =this.$store.state.repUrl+ row['REPURL']+'&p_corpid='+this.v_corpid+'&p_idno='+row['IDNO']
            }
        },
 
        //变更物料属性
        propSure(){
            if (this.v_prop =='OUT' && !this.v_supno){
                this.promptWin =true
                this.prompt =this.$LANG('1432', '属性为 委外时，供应商不能为空')
            }else {
                this.loadWin =true  // 
                let v_cond =' set stfg=\''+this.v_prop+'\''
                if (this.v_supno ) {
                    v_cond = ' set stfg=\''+this.v_prop+'\',supno=\'' + this.v_supno +'\''
                }else {
                    v_cond = ' set stfg=\''+this.v_prop+'\',supno=null ' 
                }
                let v_where =' and (idseq,lstseq) in (select idseq,lstseq from (select * from mrp_dtl start with  idseq='+this.v_idseq+' and lstseq='+this.v_lstseq+'  connect by prior matno=parentno ) where matno not like \'m%\')' 
 
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_table:'mrp_dtl',p_cond: v_cond,p_where:v_where},
                }).then(res=>{ 
                    //重新查询
                    this.getBomList(this.v_idseq)
                    this.loadWin =false
                    this.propWin =false
                })
            }
        },
        setType(row){
            this.propWin =true
            this.v_idseq =row.idseq
            this.v_lstseq=row.lstseq
            this.v_matno =row.matno
            this.v_label =row.label
            this.v_fee =row.pcscost
            this.v_prop =row.stfg=='自制'?'IN': row.stfg=='委外'?'OUT':row.stfg=='客供'?'CLNT':'PO'
            if (this.v_prop =='OUT'){
                this.supFlag =false
            }else{
                this.supFlag =true
            }
            this.$nextTick(()=>{
                this.v_supno =row.supidno
            })
        },
 
        delCate(row,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此行记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
   
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row['IDSEQ'],p_key2:'lstseq',p_value2:row['LSTSEQ'],  p_table:'IC_STKLOG_DTL' },
                }).then(res=>{
                    this.lockData.splice(index,1)
                    this.getLockData(this.p_idseq,this.p_lstseq)
                    this.getStkData(row['MATNO'])              
                    this.getReqList(this.p_idseq  )

             
                })
            }).catch(()=>{})
        },
        //分配数量
        alloCate(row){
            if (!row['ALLOQTY']){
                this.promptWin =true
                this.prompt =this.$LANG('1704', '请填写分配数量')
            }else if (row['ALLOQTY']>row['OKQTY']){
                this.promptWin =true
                this.prompt =this.$LANG('0808', '分配数量不能大于可用数量')
            }else if ( row['OKQTY']<=0 ){
                this.promptWin =true
                this.prompt =this.$LANG('1363', '可用数量要大于') + '0'
            }else{
                this.$confirm(this.$LANG('1577', '你确定要分配数量吗'),this.$LANG('1442', '提示'),{
                    confirmButtonText: this.$LANG('1638', '确定'),
                    cancelButtonText:this.$LANG('0132', '取消'),
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    this.$axios({
                        method: 'post',
                        url: 'xuper_auth/tableBodySave',
                        data: {p_json:JSON.stringify(Object.assign(row,{REQSEQ:this.p_idseq,REQITM:this.p_lstseq,QTY:row['ALLOQTY']} )), p_table:'IC_STKLOG_DTL',p_idseq:row['IDSEQ']},
                    }).then(res =>{
                        if (res.code !=='200'){
                            this.promptWin =true
                            this.prompt =res.result
                        }else{
                            this.getLockData(this.p_idseq,this.p_lstseq)
                            this.getStkData(row['MATNO'])
                            this.getReqList(this.p_idseq )
                        }
                    })
                }).catch(()=>{})
            }
        },
        //锁库
        recLock(row,index){
            this.p_idseq =row['IDSEQ']
            this.p_lstseq=row['LSTSEQ']
            this.v_lockRec =JSON.parse(JSON.stringify(row))
            this.stkWin =true
            //仓库明细
            this.getStkData(row['MATNO'])
            //已分配数据明细
            this.getLockData(row['IDSEQ'],row['LSTSEQ'])
        },
        empAllo(row,index){
            this.e_row=JSON.parse(JSON.stringify(row))
 
            this.v_table ='v_hr_emp'
            this.pubCol =this.empCol
            this.v_key2 =''
            this.v_value2 = ''
            this.btnWin =true
        },
        getStkData(p_matno){
            this.stkData =[]
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'corpid', p_value:this.v_corpid, p_key2:'matno',p_value2:p_matno,p_table:'V_IC_STKLOG'},
            }).then(res=>{                
                this.stkData =res.result
                this.$nextTick(()=>{
                    this.$refs['refstk'].doLayout()
                })
            })
        },
        getLockData(p_idseq,p_lstseq){
            this.lockData=[]
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'corpid', p_value:this.v_corpid, p_key2:'reqseq',p_value2:p_idseq,p_key3:'reqitm',p_value3:p_lstseq,p_table:'V_IC_STKLOG_DTL'},
            }).then(res=>{ 
                this.lockData =res.result
                this.$nextTick(()=>{
                    this.$refs['reflock'].doLayout()
                })
            })
        },
       
        mrpSure(){
            //开始运算
            this.$confirm(this.$LANG('1581', '你确定要开始运算吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{                
                let v_action =this.v_stk +this.v_safe+this.v_lost 
                if (this.matData.length >0) {
                    this.loadWin =true
                    this.selData =[]
                    let v_idseq=''
                    this.matData.forEach((item ,index)=>{
                        this.selData.push(item['IDSEQ']+'-'+item['LSTSEQ'])
                        v_idseq = item['IDSEQ']
                    })
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/mrp_Calc',
                        data: {corpid:this.v_corpid,p_json:JSON.stringify(this.selData) ,p_action:v_action},
                    }).then(res=>{                                 
                        if(res.code !=='200')  {                               
                            this.prompt=res.result
                            this.promptWin=true
                            this.loadWin =false
                        }else{
             
                            this.condWin =false 
                            
                            this.mrpClick(v_idseq,'')
                          
                            this.getOrdMat(v_idseq)
                            this.loadWin =false                           
                     
                        }     
                    })                     
                }else{
                    this.promptWin =true
                    this.prompt =this.$LANG('1905', '此销售订单没有明细可运算，请核查')
                } 
            }).catch(()=>{})
        },
        //运算
        mrpCalc(row ){
            //event.stopPropagation()
            if (row['ISMRP']=='Y' && row['MRPDTTM']<'2025-12-21'){
                this.promptWin =true
                this.prompt =this.$LANG('1934', '由于之前已产生需求单，现改变了运算方式，不能重新运算')
            }else{
                this.t_idseq = row['IDSEQ']
                this.condWin =true   
                this.v_stk ='N'
                this.v_safe='N'
                this.v_lost ='N'     
            }
        },
        //查询
        inputQry(){
            let cond_=' and 1=1 '
            if (this.selparam !=='ALL' ){ //列1
                cond_ =' and ismrp=\'' +this.selparam+'\''
            }
            let v_cond ='',v_edcss=''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.ordArr.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })   
                    if (v_edcss =='number'){
                        v_cond =v_cond +' and '+item+'='+  this.v_row[item] 
                    }else{
                        v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                    }
                }
            })
            this.getOrdList( cond_+v_cond)
            this.v_active='one'
        },
        getRowKey(row){
            return row.PKID 
        },
        getModKey(row){
            return row.IDSEQ 
        },
        getMrpKey(row){
            return row.IDSEQ 
        },
        getDtlKey(row){
            return row.IDSEQ+'-'+row['LSTSEQ']
        },
        //订单明细
        getOrdList(cond){    
            this.v_loading =true   
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'corpid', p_value:this.v_corpid,p_cond:cond+'  order by  ORDDTTM DESC,IDNO DESC',p_table:'V_ORD_MRP'},
            }).then(res=>{ 
                this.ordData =res.result
                this.originData =res.result
                let idnoSet =new Set(res.result.map(item => item['IDNO']))
                this.mapData =[...idnoSet] //.map(idno=>({IDNO:idno }))
 
                if (res.result.length>0){
                    this.p_idseq =res.result[0]['IDSEQ']
                    let v_lstseq =res.result[0]['LSTSEQ']
                    this.getOrdMat(this.p_idseq)

                    this.$refs['tabref'].setCurrentRow(res.result[0])
 
                    this.mrpClick(this.p_idseq,v_lstseq)
                }else{
 
                    this.mrpClick(0,'')
                    this.getOrdMat(0)

                }
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.tabref.doLayout()
                    this.v_loading =false
                })
            }) 
        },
        //获取订单下 的 产品编码
        getOrdMat(v_idseq){
            this.matData =[]
            this.treeData =[]
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'idseq',p_value:v_idseq,p_table:'V_ORDITM_PLAN'},
            }).then(res=>{ 
                this.matData =res.result
                // 获取 第一个 产品下 的物料计划 主键
                if (this.matData.length>0) {
                    let t_idseq =this.matData[0]['IDSEQ'] ,t_lstseq =this.matData[0]['LSTSEQ']
                    this.$axios({   
                        method: 'post',
                        url:'xuper_auth/getBaseData',
                        data: { p_key:'refidseq',p_value:t_idseq,p_key2:'reflstseq',p_value2:t_lstseq,p_table:'V_mrp'},
                    }).then(res=>{ 
                        if (res.result.length >0)
                        this.getBomList(res.result[0]['IDSEQ'])
                    })
                }
            })
        },
        enterDown(){
            let v_cond ='' , v_oper='like' ,v_edcss=''
            Object.keys(this.v_inputrow).filter(item=>item.indexOf('#OPER')<0 && item !=='SEL').forEach(item=>{
                if (this.v_inputrow[item] ){
                    this.vueCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (this.v_inputrow[`#OPER`+item]){
                        v_oper =this.v_inputrow[`#OPER`+item]
                    }
                    if (v_edcss =='number' ){
                        if (v_oper=='like'){
                            v_oper ='='
                        }
                        v_cond =v_cond +' and '+item+ v_oper +  this.v_inputrow[item] 
                    }else if ( v_edcss=='date'){
                        if (v_oper =='like'){
                            v_cond =v_cond +' and '+item+ ' like \''+this.v_inputrow[item] +'%\''
                        }else {
                            v_cond =v_cond +' and '+item+ v_oper +'\''+this.v_inputrow[item] +'\''
                        }
                    }else{                        
                        v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_inputrow[item]).toLowerCase().trim()+'%\''
                        
                    }                   
                }
            })
            //console.log(v_cond,'...' )
            this.getReqData(this.p_idseq, v_cond)
        },

        rowDel(){
            Object.keys(this.v_inputrow).forEach(item=>{
                this.v_inputrow[item] =''
            })
            this.getReqData(this.p_idseq ,'')
        } ,
        enterItem(){
            let v_cond ='' , v_oper='like' ,v_edcss=''
            Object.keys(this.v_reqrow).filter(item=>item.indexOf('#OPER')<0).forEach(item=>{
                if (this.v_reqrow[item] ){
                    this.itemCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (this.v_reqrow[`#OPER`+item]){
                        v_oper =this.v_reqrow[`#OPER`+item]
                    }
                    if (v_edcss =='number' ){
                        if (v_oper=='like'){
                            v_oper ='='
                        }
                        v_cond =v_cond +' and '+item+ v_oper +  this.v_reqrow[item] 
                    }else if ( v_edcss=='date'){
                        if (v_oper =='like'){
                            v_cond =v_cond +' and '+item+ ' like \''+this.v_reqrow[item] +'%\''
                        }else {
                            v_cond =v_cond +' and '+item+ v_oper +'\''+this.v_reqrow[item] +'\''
                        }
                    }else{                        
                        v_cond =v_cond +' and  '+item+'  like \'%'+ (this.v_reqrow[item]).trim()+'%\''
                        
                    }                   
                }
            })
            this.getItemData(this.p_idseq,this.r_lstseq, v_cond)
        },
        //明细清除字段条件
        itemDel(){
            this.v_reqrow={}
            this.getItemData(this.p_idseq ,this.r_lstseq,'')
        } ,
        hideChg(){
            this.getReqData(this.p_idseq ,'')
        },
        //请购汇总
        getReqData(v_idseq,v_cond ){
            this.reqData =[]
            this.loadingInstance.show() 
            if (this.v_isfin =='Y'){
                v_cond =v_cond + ' and postfg!=\'已完成\' '
            }
            this.v_poRow ={}
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'ordseq', p_value:v_idseq, p_table:'V_po_reqdtl',p_cond:v_cond+ ' order by idno, matno'},
            }).then(res=>{ 
                this.reqData =res.result  
                if (this.reqData.length>0){
                    this.v_poRow =this.reqData[0]
                }
                this.$nextTick(()=>{
                    this.getReqSum()
                    this.loadingInstance.close() 
                })
            })
        },
        //请购 订单产品对应明细
        getItemData(v_idseq,v_lstseq,v_cond ){
            this.itemData =[]
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'ord_idseq', p_value:v_idseq,p_key2:'ord_lstseq', p_value2:v_lstseq, p_table:'V_po_reqitm',p_cond: v_cond +' order by  matno'},
            }).then(res=>{ 
                this.itemData =res.result  
                this.getFootSum()
            })
        },
        //投料明细
        getPckData(v_taskno){
            this.pckData =[]
            this.pckInstance.show() 
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'taskno', p_value:v_taskno, p_table:'V_PC_PICKDTL_QRY',p_cond: ' order by  matno'},
            }).then(res=>{ 
                this.pckData =res.result  
                this.$nextTick(()=>{
                    this.pckInstance.close()
                    this.getPckSum()                     
                })
            })
        },
        getReqList(v_idseq ){
            this.reqData =[]
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'idseq', p_value:v_idseq,  p_table:'V_po_reqdtl',p_cond: ' order by idno, matno'},
            }).then(res=>{ 
                if (res.code=='200'){
                   this.reqData =res.result  
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                }
            })
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
            // if (row['ISMRP']=='Y' ){
            //     return 'ok-row'
            // } 
        },
        pckClick(row){
            this.getPckData(row['IDNO'])
        },
        ordClick(row){
            this.p_idseq =row['IDSEQ']
            this.r_lstseq=row['LSTSEQ']
            this.getOrdMat(row['IDSEQ'])
            this.mrpClick(row['IDSEQ'],row['LSTSEQ']) 
            this.v_active='one'
        },
        treeClick(row){
            let v_pkid =row.usetool
            let v_idseq =v_pkid.substring(0,v_pkid.indexOf('-'))
            let v_lstseq =v_pkid.substring(v_pkid.indexOf('-')+1)
            //console.log( v_idseq,v_lstseq )
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'idseq', p_value:v_idseq,p_key2:'lstseq', p_value2:v_lstseq,  p_table:'mrp_dtl' },
            }).then(res=>{ 
                if (res.result.length>0){
                    let v_matno =res.result[0]['MATNO']
                    let v_data =[]
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/getFreeData',
                        data: {p_cond: 'select case when instr(matno,\'@\')>0 then substr(matno,1,instr(matno,\'@\')-1) else matno end code_ '+
                         ' from (SELECT * from V_MRP_DTLQRY start with idseq ='+v_idseq+' and matno =\''+v_matno+'\' connect by prior matno =parentno ) where matno like \'m%\''  },
                    }).then(res=>{ 
                        if (res.code=='200'){
                            v_data =res.result
                            if (v_data.length>0){
                                let v_cond =' and matno in ('+v_data.map(item=> `'${item['CODE_']}'` ).join(',')+')'
                                this.getReqData(this.p_idseq ,v_cond)
                            }else{
                                this.reqData =[]
                            }
                        }
             
                    })  
                }
            })
        },
        //列排序
        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            } 
            this.vueCol.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.reqData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){ //a == null ? -1 : b == null ? 1 : 0
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 :   a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 :  b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]==null?'':a[v_key].toUpperCase() 
                    let nameB = b[v_key]==null?'':b[v_key].toUpperCase()    
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 :  nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
        sortItem(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            } 
            this.itemCol.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.itemData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){ //a == null ? -1 : b == null ? 1 : 0
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 :   a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 :  b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]==null?'':a[v_key].toUpperCase() 
                    let nameB = b[v_key]==null?'':b[v_key].toUpperCase()    
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 :  nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
        sortPck(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            } 
            this.pckCol.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.pckData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){ //a == null ? -1 : b == null ? 1 : 0
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 :   a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 :  b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]==null?'':a[v_key].toUpperCase() 
                    let nameB = b[v_key]==null?'':b[v_key].toUpperCase()    
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 :  nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
        mrpClick(v_idseq,v_lstseq){
            this.v_ordseq=v_idseq
            // 物料状态表
            this.getReqData(v_idseq,'' )
            this.getTaskList(v_idseq)
            //明细记录
 
            this.getItemData(v_idseq,v_lstseq,'')
            this.pckData =[]
        },
        inputChg(e,column){
            this.v_inputrow[column]=e.target.value
            this.v_row[column] =e.target.value
        },
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16572','lstseq','2088','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.ordArr.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        sortable:res.result[k].SORTABLE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
 
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16572','lstseq','2095','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.stkCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        sortable:res.result[k].SORTABLE,
                        disabled:res.result[k].DISABLED,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16572','lstseq','2096','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.lockCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        sortable:res.result[k].SORTABLE,
                        disabled:res.result[k].DISABLED,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16572','lstseq','2089','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.taskCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4204','lstseq','4','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.empCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16572','lstseq','2103','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tableCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        sortable:res.result[k].SORTABLE,
                        disabled:res.result[k].DISABLED,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16572','lstseq','2097','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    let itcol =res.result[k]
                    if (itcol.THIDE=='N'){
                        let v_obj ={   //向数组的开头 添加序列号
                            field:itcol['key'] ,
                            title: vm.$translate.getColTitle(itcol, vm.$store.state.lang),
                            key: itcol['key']  ,
                            align: itcol.align,                                
                            width: Number(itcol.width),
                            thide:itcol.THIDE,
                            edcss:itcol.EDCSS,
                            fhide:itcol.FHIDE,
                            fixed: itcol['key']=='SEL'?'left':itcol['key']=='IDNO'?'left':itcol['key']=='MATNO'?'left':'',
                            renderHeaderCell: ({column}, h) => {                           
                                if (itcol.EDCSS =='number') {
                                    return (                              
                                        <div >
                                            <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                                
                                            </div>                        
                                            <div style="display:flex">
                                                <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_inputrow[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>                                                        
                                                    <option    value="=" style="height:30px;line-height:30px">=</option>
                                                    <option    value=">" style="height:30px;line-height:30px">&gt;</option>
                                                    <option    value="<" style="height:30px;line-height:30px">&lt;</option>
                                                    <option    value="!=" style="height:30px;line-height:30px">!=</option>
                                                </select>
                                                <input  placeholder={this.$LANG('1663', '请输入')}  disabled={itcol.EDCSS=='checkbox'}  v-model={this.v_inputrow[column.key]}  onKeyup={(e) => e.key === 'Enter' && this.enterDown()}  style=" margin-top:1px;width:100%;height:28px; " size="mini"/> 
                                            </div>
                                        </div>                                   
                                    )
                                }else if (itcol['key']=='POSTFG'){
                                    return (   
                                        <div >
                                            <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                                
                                            </div>                        
                                            <div style="display:flex">
                                                <el-select size="mini" style="width:100%; background:white;height:28px;margin-top:1px" v-model={this.v_inputrow[column.key]} on-change={()=>this.enterDown() }>                                                        
                                                    <el-option    value="未开始" style="height:30px;line-height:30px">未开始</el-option>
                                                    <el-option    value="进行中" style="height:30px;line-height:30px">进行中</el-option>
                                                    <el-option    value="已完成" style="height:30px;line-height:30px">已完成</el-option>
                                                    <el-option    value="异常" style="height:30px;line-height:30px">异常</el-option>
                                                    <el-option    value="加急" style="height:30px;line-height:30px">加急</el-option>
                                                </el-select>
    
                                            </div>
                                        </div> 
                                    )
                                }else if (itcol['key']=='IDNO'){
                                    return (                              
                                        <div >
                                            <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                <el-link underline={false} style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                            </div>  
                                            <div style="display:flex">
                                                <el-button size="mini" on-click={()=>this.stfgRec()} type="warning" style="height:25px;width:100%;margin-top:2px">{this.$LANG('0134', '审核')}</el-button>
                                            </div>
                                        </div>                                   
                                    )
                                } else if (itcol['key']=='SEL'){
                                    return (                              
                                        <div >
                                            <div style="margin-top:3px;display:flex;white-space: nowrap;margin-left:5px " >
                                                <el-link underline={false} style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                            </div>  
                                            <div style="display:flex; margin-left:8px">
                                                <el-checkbox size="mini" v-model={this.v_inputrow[column.key]} on-change={()=>this.reqChg(this.v_inputrow[column.key]) } true-label="Y" false-label="N" > </el-checkbox> 
                                            </div>
                                        </div>                                   
                                    )
                                }  else{
                                    return (                              
                                        <div >
                                            <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                            </div>  
                                            <div style="display:flex">
                                                <input  placeholder={this.$LANG('1663', '请输入')}  disabled={itcol.EDCSS=='checkbox'}  v-model={this.v_inputrow[column.key]}  onKeyup={(e) => e.key === 'Enter' && this.enterDown()} style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"/>
                                            </div>
                                        </div>                                   
                                    )
                                }                            
                            },
                            disabled:itcol.DISABLED,
                            ellipsis: { showTitle: true, },
                            renderBodyCell: ({row,column,rowIndex},h) => {
                                let  rowVal =row[itcol['key'] ]
                                if (column.key=='PONO') { 
                                    return (                                           
                                        <el-link  underline={false} on-click={()=>{this.repShow( row,'PONO')}}><span style=" border-bottom:1px solid red;font-size:12px;font-weight:700  " title={rowVal}>{rowVal}</span> </el-link>    
                                    )
                                }else if (column.key=='IDNO') { 
                                    return (                                           
                                        <el-link  underline={false} on-click={()=>{this.repShow( row,'REQNO')}}><span style=" border-bottom:1px solid red;font-size:12px;font-weight:700  " title={rowVal}>{rowVal}</span> </el-link>    
                                    )
                                } else if (itcol.EDCSS =='checkbox') {                         
                                    if (column.key=='SEL'){
                                        return (<el-checkbox v-model={ row[itcol['key']] } disabled={row['STFG']!=='Y'} true-label="Y" false-label="N" > </el-checkbox> )
                                    }else {
                                         return (<el-checkbox disabled  true-label="Y" false-label="N" > </el-checkbox> )
                                    }                                          
                                } else{
                                    return row[itcol['key'] ]
                                }
                            },                                
                        }
                        this.vueCol.push(v_obj)
                    }    
                }
                // 分组 字段
                let v_rownum ={
                    field: "index",
                    key: "rownum",
                    title: this.$LANG('0310', '序号'),
                    width: 50,
                    align: "left",
                    fixed:"left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (<span style="color:#1890ff;">
                            {rowIndex + this.startRowIndex + 1}
                        </span> )
                    },
                    renderHeaderCell: ({column}, h) => {
                        return (  
                            <div >
                                <div style="margin-top:3px">{column.title}</div>
                                <el-link on-click={()=>{this.rowDel()}} style="font-size:12px;color:#404eff;height:30px"> 
                                    <el-tooltip content={this.$LANG('0852', ' 清除条件')} effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </div>
                        )
                    },
                }
                let v_oper ={
                    field: "oper0",
                    key: "oper",
                    title: this.$LANG('0330', '操作'),
                    width:125,
                    align: "center",
                    fixed:"right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {               
                        return ( 
                            <div>
                                <i class="iconfont icon-lock" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link  disabled={this.cancelBool} on-click={()=>{this.recLock(row,rowIndex )}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0410', '锁库')}</span></el-link>
                                <i class="iconfont icon-fuzeren" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link  disabled={this.cancelBool} on-click={()=>{this.empAllo(row,rowIndex )}}  underline={false} ><span style="font-size:12px; ">{this.$LANG('0504', '负责人')}</span></el-link>
                            </div>                                
                        )     
                    },
                }
                let v_type ={
                    field: "",
                    key: "a",
                    title: "#",
                    width:30,
                    align: "center",
                    fixed:"left",
                    type: "expand",
                }
                this.vueCol.unshift(v_type) 
                this.vueCol.unshift(v_rownum) 
                this.vueCol.push(v_oper)
                this.getSetList()
         
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16572','lstseq','2099','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.treeCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: (res.result[k].key).toLowerCase(),
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        notnull:res.result[k].NOTNULL,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','414357','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.modCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM, 
                        holder:res.result[k].HOLDER,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16572','lstseq','2100','','',' order by sortby,lstseq').then((res) => {
                vm.itemInitCol =res.result
                return vm.loadInitialFieldSettings('item').then(() => {
                vm.itemCol =[]
                const fieldRows =vm.sortFieldRows(vm.itemInitCol, 'item')
                for (let k=0; k<fieldRows.length; k++){
                    let itcol =fieldRows[k]
                    if (itcol.THIDE=='N'){
                        let v_obj ={   //向数组的开头 添加序列号
                            field:itcol['key'] ,
                            title: vm.$translate.getColTitle(itcol, vm.$store.state.lang),
                            key: itcol['key']  ,
                            align: itcol.align,                                
                            width: Number(itcol.width),
                            thide:itcol.THIDE,
                            fhide:itcol.FHIDE,
                            fixed: itcol['key']=='SEL'?'left':itcol['key']=='IDNO'?'left':itcol['key']=='MATNO'?'left':'',
                            renderHeaderCell: ({column}, h) => {                           
                                if (itcol.EDCSS =='number') {
                                    return (                              
                                        <div >
                                            <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                <el-link underline={false} on-click={()=>{this.sortItem(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                                
                                            </div>                        
                                            <div style="display:flex">
                                                <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_reqrow[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>                                                        
                                                    <option    value="=" style="height:30px;line-height:30px">=</option>
                                                    <option    value=">" style="height:30px;line-height:30px">&gt;</option>
                                                    <option    value="<" style="height:30px;line-height:30px">&lt;</option>
                                                    <option    value="!=" style="height:30px;line-height:30px">!=</option>
                                                </select>
                                                <el-input  placeholder={this.$LANG('1663', '请输入')}  disabled={itcol.EDCSS=='checkbox'}  v-model={this.v_reqrow[column.key]}   on-change={()=>this.enterItem() } style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></el-input>
                                            </div>
                                        </div>                                   
                                    )
                                }else{
                                    return (                              
                                        <div >
                                            <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                <el-link underline={false} on-click={()=>{this.sortItem(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                            </div>  
                                            <div style="display:flex">
                                                <el-input  placeholder={this.$LANG('1663', '请输入')}  disabled={itcol.EDCSS=='checkbox'}  v-model={this.v_reqrow[column.key]}   on-change={()=>this.enterItem() } style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></el-input>
                                            </div>
                                        </div>                                   
                                    )
                                }                            
                            },
                            disabled:itcol.DISABLED,
                            ellipsis: { showTitle: true, },
                            renderBodyCell: ({row,column,rowIndex},h) => {
                                let  rowVal =row[itcol['key'] ]
                                if (itcol.EDCSS =='checkbox') {                                 
                                    return (<el-checkbox disabled  true-label="Y" false-label="N" > </el-checkbox> )                                      
                                } else{
                                    return row[itcol['key'] ]
                                }
                            },                                
                        }
                        this.itemCol.push(v_obj)
                    }    
                }
                // 分组 字段
                let v_rownum ={
                    field: "index",
                    key: "rownum",
                    title: this.$LANG('0310', '序号'),
                    width: 50,
                    align: "center",
                    fixed:"left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (<span style="color:#1890ff;">
                            {rowIndex + this.startRowIndex + 1}
                        </span> )
                    },
                    renderHeaderCell: ({column}, h) => {
                        return (  
                            <div >
                                <div style="margin-top:3px">{column.title}</div>
                                <el-link on-click={()=>{this.itemDel()}} style="font-size:12px;color:#404eff;height:30px"> 
                                    <el-tooltip content={this.$LANG('0852', ' 清除条件')} effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </div>
                        )
                    },
                }
                this.itemCol.unshift(v_rownum) 
                this.applyFieldSettingRows('item')
                })
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16572','lstseq','2101','','',' order by sortby,lstseq').then((res) => {
                vm.pckInitCol =res.result
                return vm.loadInitialFieldSettings('pack').then(() => {
                vm.pckCol =[]
                const fieldRows =vm.sortFieldRows(vm.pckInitCol, 'pack')
                for (let k=0; k<fieldRows.length; k++){
                    let itcol =fieldRows[k]
                    if (itcol.THIDE=='N'){
                        let v_obj ={   //向数组的开头 添加序列号
                            field:itcol['key'] ,
                            title: vm.$translate.getColTitle(itcol, vm.$store.state.lang),
                            key: itcol['key']  ,
                            align: itcol.align,                                
                            width: Number(itcol.width),
                            thide:itcol.THIDE,
                            fhide:itcol.FHIDE,
                            fixed: itcol['key']=='SEL'?'left':'',
                            renderHeaderCell: ({column}, h) => {                           
                                if (itcol.EDCSS =='number') {
                                    return (                              
                                        <div >
                                            <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                <el-link underline={false} on-click={()=>{this.sortPck(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                                
                                            </div>                        
                                            <div style="display:flex">
                                                <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_reqrow[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>                                                        
                                                    <option    value="=" style="height:30px;line-height:30px">=</option>
                                                    <option    value=">" style="height:30px;line-height:30px">&gt;</option>
                                                    <option    value="<" style="height:30px;line-height:30px">&lt;</option>
                                                    <option    value="!=" style="height:30px;line-height:30px">!=</option>
                                                </select>
                                                <el-input  placeholder={this.$LANG('1663', '请输入')}  disabled={itcol.EDCSS=='checkbox'}  v-model={this.v_reqrow[column.key]}   on-change={()=>this.enterItem() } style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></el-input>
                                            </div>
                                        </div>                                   
                                    )
                                }else{
                                    return (                              
                                        <div >
                                            <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                <el-link underline={false} on-click={()=>{this.sortPck(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                            </div>  
                                            <div style="display:flex">
                                                <el-input  placeholder={this.$LANG('1663', '请输入')}  disabled={itcol.EDCSS=='checkbox'}  v-model={this.v_reqrow[column.key]}   on-change={()=>this.enterItem() } style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></el-input>
                                            </div>
                                        </div>                                   
                                    )
                                }                            
                            },
                            disabled:itcol.DISABLED,
                            ellipsis: { showTitle: true, },
                            renderBodyCell: ({row,column,rowIndex},h) => {
                                let  rowVal =row[itcol['key'] ]
                                if (itcol.EDCSS =='checkbox') {                                 
                                    return (<el-checkbox disabled  true-label="Y" false-label="N" > </el-checkbox> )                                      
                                } else{
                                    return row[itcol['key'] ]
                                }
                            },                                
                        }
                        this.pckCol.push(v_obj)
                    }    
                }
                // 分组 字段
                let v_rownum ={
                    field: "index",
                    key: "rownum",
                    title: this.$LANG('0310', '序号'),
                    width: 50,
                    align: "center",
                    fixed:"left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (<span style="color:#1890ff;">
                            {rowIndex + this.startRowIndex + 1}
                        </span> )
                    },
                    renderHeaderCell: ({column}, h) => {
                        return (  
                            <div >
                                <div style="margin-top:3px">{column.title}</div>
                                <el-link on-click={()=>{this.itemDel()}} style="font-size:12px;color:#404eff;height:30px"> 
                                    <el-tooltip content={this.$LANG('0852', ' 清除条件')} effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </div>
                        )
                    },
                }
                this.pckCol.unshift(v_rownum) 
                this.applyFieldSettingRows('pack')
                })
            })
        }
    }
}
</script>
<style lang="less" scoped>
    .right-top-table-wrap {
        width: 100%;
        overflow: hidden;
        flex-shrink: 0;
    }
    .table-resize-bar:hover {
        background: #e6f7ff !important;
    }
    .table-resize-bar:hover div {
        background: #1890ff !important;
    }
    
    .tab_active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
        cursor: pointer;
    }
    .active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
        cursor: pointer;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    /* 核心修复：强制ve-table内部所有层级容器都撑满父级高度 */
    .ve-table {
        height: 100% !important;
        width: 100% !important;
    }
    .ve-table .ve-table-container {
        height: 100% !important;
    }
    .ve-table .vt-body-wrapper {
        overflow-y: auto !important; /* 强制开启纵向滚动 */
    }
    .ve-table .vt-body-content {
        min-height: 100% !important;
    }
    .table-foot-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #b2d3fa !important;
        font-weight:700 !important;
        padding: 2px !important;
        line-height: 25px !important;
        text-align:left !important;
        height: 15px !important;
   
    }
    .table-head-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        padding:0px !important;
        padding-top:4px !important;
        text-align:center !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    .table-head-cell-class2 {
        font-size: 12px !important;
        color: #4b033f !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        padding:0px !important;
        padding-top:4px !important;
        text-align:center !important;
        border-width: 1px !important;
        border-color: #f70d0d !important;
    }
    .table-body-cell-class1 {
        font-size: 12px !important;
        color: gray !important;
        border-width: 1px !important;
        padding-left:2px !important;
        height: 20px  !important;
 
        border-color: #808695 !important;
        border-bottom:1px solid #808695 !important;
    }
    .table-body-cell-green {
        font-size: 12px !important;
        color: green !important;
        border-width: 1px !important;
        padding-left:2px !important;
        padding-top:0px !important;
        padding-bottom:0px !important;
        border-color: #808695 !important;
        border-bottom:1px solid #808695 !important;
    }
    .table-body-cell-yellow {
        font-size: 12px !important;
        color: rgb(255, 165, 0) !important;
        border-width: 1px !important;
        padding-left:2px !important;
        padding-top:0px !important;
        padding-bottom:0px !important;
        border-color: #808695 !important;
        border-bottom:1px solid #808695 !important;
    }
    .table-body-cell-red {
        font-size: 12px !important;
        color: red !important;
        border-width: 1px !important;
        padding-left:2px !important;
        padding-top:0px !important;
        padding-bottom:0px !important;
        border-color: #808695 !important;
        border-bottom:1px solid #808695 !important;
    }
    .table-body-cell-blue {
        font-size: 12px !important;
        color: blue !important;
        border-width: 1px !important;
        padding-left:2px !important;
        padding-top:0px !important;
        padding-bottom:0px !important;
        border-color: #808695 !important;
        border-bottom:1px solid #808695 !important;
    }
    .el-icon-arrow-right {
        color:#ff0000;
    }
    .el-table .el-table__expand-icon{
        .el-icon-arrow-right:before{
            content: '\e791';
        }
    }
 
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
 
    .el-table .ok-row  {
        color: green;
        font-weight:700;
    }
 
    .el-table {
        th{
            padding: 0 ;
            display: table-cell!important;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-table__fixed {
        z-index: 10 !important;
    }
    .upper-layout {
        z-index: 1;
    }
 
</style>
